import React from "react";
import {Box, Stack, Typography} from "@mui/material";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";

export default function TitleWithBackButton(props: {
  title: string,
  onClick: () => void,
  prevText: string,
  // eslint-disable-next-line react/require-default-props
  actionText?: string
}) {
  return (
    <Stack gap={1} justifyContent='end'>
      <Box display='flex' flexWrap='nowrap' justifyContent='space-between' alignItems='center'>
        <Typography variant="h6" sx={{fontWeight: "bold"}}>
          {props.title}
        </Typography>

        <Pjdb1Button
          label={props.prevText}
          type='button'
          variant='text'
          color='inherit'
          onClick={props.onClick}
        />
      </Box>
      {props.actionText && (
        <Typography variant="subtitle2" sx={{fontWeight: "bold"}}>
          {props.actionText}
        </Typography>
      )}
    </Stack>
  );
}
